import i18n from '@shared/i18n';

export enum STATUS_CATEGORY {
    UNPAID = 'unpaid',
    PAID = 'paid',
    UNPICKED = 'unpicked',
    COMPLETE = 'complete',
    REFUND = 'refund',
    CANCEL = 'cancel',
}

export enum PAYMENT_STATUS {
    IN_PROCESS = 'in_process',
    UNPAID = 'unpaid',
    PAID = 'paid',
    EXPIRED = 'expired',
    FAILED = 'failed',
    REJECTED = 'rejected',
    REFUNDED = 'refunded',
}

export enum PAYMENT_TYPE {
    CREDIT_CARD = 'credit_card',
    SEVEN_PAYMENT = 'seven_payment',
    SEVEN_COD = 'seven_cod',
}

export enum INVOICE_TYPE {
    MOBILE_BARCODE = 'mobile_barcode',
    EXEMPT = 'exempt',
    PAPER = 'paper',
    BUSINESS = 'business',
    NATURAL_ID = 'natural_id',
    DONATE = 'donate',
    PRINTED_E_INVOICE = 'printed_e_invoice',
}

export enum INVOICE_INFO {
    MOBILE_BARCODE = 'mobile_barcode',
    NATURAL_ID = 'natural_id',
    TAX_ID = 'tax_id',
    TAX_TITLE = 'tax_title',
    LOVE_CODE = 'love_code',
}

export enum ORDER_STATUS {
    UNPAID = 'unpaid',
    UNSHIPPED = 'unshipped',
    SHIPPED = 'shipped',
    NEED_RESELECT = 'need_reselect',
    UN_REMIT = 'un_remit',
    REMITTED = 'remitted',
    CANCELED = 'canceled',
    REFUND_REQUESTED = 'refund_requested',
    REFUND_CONFIRMED = 'refund_confirmed',
    REFUND_REJECTED = 'refund_rejected',
    REFUNDED = 'refunded',
    EXCEPTION = 'exception',
}

export enum DESCRIPTION_TYPE {
    WAITING_FOR_PAYMENT = 'waiting_for_payment',
    WAITING_FOR_SHIPMENT = 'waiting_for_shipping',
    NEED_RESELECT = 'need_reselect',
    SHIPPED = 'shipped',
    ARRIVED = 'arrived',
    REFUNDED = 'refunded',
}

export enum SHIPPING_STATUS {
    STOCK_UP = 'stock_up',
    UNSHIPPED = 'unshipped',
    SHIPPED = 'shipped',
    NEED_RESELECT = 'need_reselect',
    ARRIVED = 'arrived',
    EXPIRED = 'expired',
    RECEIVED = 'received',
    REFUNDED = 'refunded',
    EXCEPTION = 'exception',
}

export enum REFUND_TYPE {
    FULL = 'full',
    PARTIAL = 'partial',
    AGREED = 'agreed',
}

export enum ORDER_ACTION {
    REPURCHASE = 'repurchase',
    BUY_AGAIN = 'buy_again',
    REFUND = 'refund',
    REFUND_AND_RETURN = 'refund_and_return',
    CANCEL = 'cancel',
    RESELECT = 'reselect',
    COMPLETE = 'complete',
    SELLER_REMARK = 'seller_remark',
    EDIT_TAG = 'edit_tag',
    COMPLETE_REFUND = 'complete_refund',
    REJECT_REFUND = 'reject_refund',
    COMPLETE_RETURN_AND_REFUND = 'complete_return_and_refund',
    PRINT_PICKUP_TICKET = 'print_pickup_ticket',
    PRINT_SHIPPING_TICKET = 'print_shipping_ticket',
    NOTIFY_BUYER_SHIPPED = 'notify_buyer_shipped',
    NOTIFY_BUYER_STOCK_UP = 'notify_buyer_stock_up',
    SHOW_SEVEN_C2C_INFO = 'show_seven_c2c_info',
}

export enum GIVEAWAY_TYPE {
    ORDER_GIVEAWAY = 'order_giveaway',
    PRODUCT_GIVEAWAY = 'product_giveaway',
}

export enum REMITTANCE_INFO {
    BANK_CODE = 'bank_code',
    ACCOUNT_NUMBER = 'account_number',
    ACCOUNT_NAME = 'account_name',
}

export enum SHIPPING_PROVIDER {
    SF_EXPRESS = 'sf_express',
    HCT = 'hct',
    T_CAT = 't_cat',
    POSTAL_LOGISTIC = 'postal_logistic',
    KERRY_TJ = 'kerry_tj',
    OTHER = 'other',
}

export enum PICK_UP_PRINT_LAYOUT {
    COMPACT = 'compact',
    SPLIT = 'split',
}

export enum SHIPPING_TICKET_TYPE {
    PACKING_SLIP = 'packing_slip',
    SHIPPING_LABEL = 'shipping_label',
    SEVEN_SHIPPING_LABEL = 'seven_shipping_label',
}

export enum SHIPPING_LABEL_OPTIONAL_FIELD {
    PHONE_NUMBER = 'phone_number',
    SERIAL_NUMBER = 'serial_number',
    CREATE_DATETIME = 'create_datetime',
}

export enum PACKING_SLIP_OPTIONAL_FIELD {
    SERIAL_NUMBER = 'serial_number',
    CREATE_DATETIME = 'create_datetime',
    RECEIVER_INFO = 'receiver_info',
    INVOICE_DETAIL = 'invoice_detail',
    ORDER_DETAIL = 'order_detail',
}

export const ORDER_STATUS_MAP: Record<string, string> = {
    [ORDER_STATUS.UNPAID]: i18n.gettext('尚未付款'),
    [ORDER_STATUS.UNSHIPPED]: i18n.gettext('待出貨'),
    [ORDER_STATUS.SHIPPED]: i18n.gettext('已出貨，等待訂單完成'),
    [ORDER_STATUS.UN_REMIT]: i18n.gettext('已完成（待撥款）'),
    [ORDER_STATUS.REMITTED]: i18n.gettext('已撥款'),
    [ORDER_STATUS.CANCELED]: i18n.gettext('已取消'),
    [ORDER_STATUS.NEED_RESELECT]: i18n.gettext('需重選超商門市'),
    [ORDER_STATUS.REFUND_REQUESTED]: i18n.gettext('退款待審核'),
    [ORDER_STATUS.REFUND_CONFIRMED]: i18n.gettext('等待退貨'),
    [ORDER_STATUS.REFUNDED]: i18n.gettext('退款已完成'),
    [ORDER_STATUS.REFUND_REJECTED]: i18n.gettext('退款已拒絕'),
    [ORDER_STATUS.EXCEPTION]: i18n.gettext('配送異常'),
} as const;

export const ORDER_STATUS_COLOR_MAP: Record<string, { text: string; bg: string }> = {
    [ORDER_STATUS.UNPAID]: { text: 'secondary.050', bg: 'secondary.010' },
    [ORDER_STATUS.UNSHIPPED]: { text: 'warning.060', bg: 'warning.010' },
    [ORDER_STATUS.SHIPPED]: { text: 'dynamic.040', bg: 'dynamic.010' },
    [ORDER_STATUS.UN_REMIT]: { text: 'positive.060', bg: 'positive.010' },
    [ORDER_STATUS.REMITTED]: { text: 'positive.060', bg: 'positive.010' },
    [ORDER_STATUS.CANCELED]: { text: 'neutral.090', bg: 'neutral.020' },
    [ORDER_STATUS.NEED_RESELECT]: { text: 'neutral.090', bg: 'neutral.020' },
    [ORDER_STATUS.REFUND_REQUESTED]: { text: 'secondary.050', bg: 'secondary.010' },
    [ORDER_STATUS.REFUND_CONFIRMED]: { text: 'dynamic.040', bg: 'dynamic.010' },
    [ORDER_STATUS.REFUNDED]: { text: 'positive.010', bg: 'positive.060' },
    [ORDER_STATUS.EXCEPTION]: { text: 'negative.050', bg: 'negative.010' },
} as const;

export const PAYMENT_STATUS_MAP: Record<string, string> = {
    [PAYMENT_STATUS.IN_PROCESS]: i18n.gettext('付款確認中'),
    [PAYMENT_STATUS.UNPAID]: i18n.gettext('尚未付款'),
    [PAYMENT_STATUS.PAID]: i18n.gettext('已付款'),
    [PAYMENT_STATUS.EXPIRED]: i18n.gettext('付款逾期'),
    [PAYMENT_STATUS.FAILED]: i18n.gettext('付款失敗'),
    [PAYMENT_STATUS.REJECTED]: i18n.gettext('買家申請付款拒絕'),
    [PAYMENT_STATUS.REFUNDED]: i18n.gettext('已退款'),
} as const;

export const INVOICE_TYPE_MAP: Record<string, string> = {
    [INVOICE_TYPE.MOBILE_BARCODE]: i18n.gettext('手機條碼'),
    [INVOICE_TYPE.EXEMPT]: i18n.gettext('品牌符合免辦理營業登記，無需開立統一發票'),
    [INVOICE_TYPE.PAPER]: i18n.gettext('品牌自行提供發票 / 收據，開立後將寄至購買人地址'),
    [INVOICE_TYPE.BUSINESS]: i18n.gettext('公司用收據'),
    [INVOICE_TYPE.NATURAL_ID]: i18n.gettext('自然人憑證條碼'),
    [INVOICE_TYPE.DONATE]: i18n.gettext('捐贈發票'),
    [INVOICE_TYPE.PRINTED_E_INVOICE]: i18n.gettext('索取實體發票'),
} as const;

export const INVOICE_INFO_MAP: Record<string, string> = {
    [INVOICE_INFO.MOBILE_BARCODE]: i18n.gettext('手機條碼'),
    [INVOICE_INFO.NATURAL_ID]: i18n.gettext('自然人憑證條碼'),
    [INVOICE_INFO.TAX_ID]: i18n.gettext('統一編號'),
    [INVOICE_INFO.TAX_TITLE]: i18n.gettext('發票抬頭'),
    [INVOICE_INFO.LOVE_CODE]: i18n.gettext('捐贈機構'),
} as const;

export const DESCRIPTION_TYPE_COLOR_MAP: Record<string, string> = {
    [DESCRIPTION_TYPE.WAITING_FOR_PAYMENT]: 'secondary.050',
    [DESCRIPTION_TYPE.WAITING_FOR_SHIPMENT]: 'positive.050',
    [DESCRIPTION_TYPE.NEED_RESELECT]: 'secondary.050',
    [DESCRIPTION_TYPE.SHIPPED]: 'positive.050',
    [DESCRIPTION_TYPE.ARRIVED]: 'positive.050',
    [DESCRIPTION_TYPE.REFUNDED]: 'positive.050',
} as const;

export const REFUND_TYPE_MAP: Record<string, string> = {
    [REFUND_TYPE.FULL]: i18n.gettext('全額退款'),
    [REFUND_TYPE.PARTIAL]: i18n.gettext('部分退款'),
    [REFUND_TYPE.AGREED]: i18n.gettext('協議退款'),
} as const;

export const ORDER_ACTION_MAP = {
    [ORDER_ACTION.REPURCHASE]: i18n.gettext('重新下單'),
    [ORDER_ACTION.BUY_AGAIN]: i18n.gettext('再買一次'),
    [ORDER_ACTION.REFUND]: {
        buyer: i18n.gettext('申請退款'),
        seller: i18n.gettext('退款給買家'),
    },
    [ORDER_ACTION.REFUND_AND_RETURN]: {
        buyer: i18n.gettext('申請退款'),
        seller: i18n.gettext('退款給買家'),
    },
    [ORDER_ACTION.CANCEL]: i18n.gettext('取消訂單'),
    [ORDER_ACTION.RESELECT]: i18n.gettext('重新選擇門市'),
    [ORDER_ACTION.COMPLETE]: i18n.gettext('完成訂單'),
    [ORDER_ACTION.SELLER_REMARK]: i18n.gettext('賣家備註'),
    [ORDER_ACTION.EDIT_TAG]: i18n.gettext('編輯訂單標籤'),
    [ORDER_ACTION.COMPLETE_REFUND]: i18n.gettext('同意退款'),
    [ORDER_ACTION.REJECT_REFUND]: i18n.gettext('拒絕退款'),
    [ORDER_ACTION.COMPLETE_RETURN_AND_REFUND]: i18n.gettext('已收到退貨，完成退款'),
    [ORDER_ACTION.PRINT_PICKUP_TICKET]: i18n.gettext('列印揀貨單'),
    [ORDER_ACTION.PRINT_SHIPPING_TICKET]: i18n.gettext('列印出貨單'),
    [ORDER_ACTION.NOTIFY_BUYER_SHIPPED]: i18n.gettext('通知買家已出貨'),
    [ORDER_ACTION.NOTIFY_BUYER_STOCK_UP]: i18n.gettext('通知買家已備貨'),
    [ORDER_ACTION.SHOW_SEVEN_C2C_INFO]: i18n.gettext('取得交貨便代碼'),
} as const;

export const SHIPPING_PROVIDER_MAP = {
    [SHIPPING_PROVIDER.SF_EXPRESS]: i18n.gettext('順豐速運'),
    [SHIPPING_PROVIDER.HCT]: i18n.gettext('新竹物流'),
    [SHIPPING_PROVIDER.T_CAT]: i18n.gettext('黑貓宅急便'),
    [SHIPPING_PROVIDER.POSTAL_LOGISTIC]: i18n.gettext('郵局'),
    [SHIPPING_PROVIDER.KERRY_TJ]: i18n.gettext('嘉里大榮'),
    [SHIPPING_PROVIDER.OTHER]: i18n.gettext('其他'),
} as const;
